import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6f0dec8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  for: "mediaInput"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-take-pic" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-take-pic" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-take-pic" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-videocam" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image-cd" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-file-cd" }, null, -1))
const _hoisted_9 = {
  key: 4,
  for: "fileInput"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))
const _hoisted_15 = {
  key: 1,
  class: "d-menu__wrapper"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image-cd" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-file-cd" }, null, -1))
const _hoisted_18 = { for: "fileInput" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!
  const _component_app_take_photo = _resolveComponent("app-take-photo")!
  const _component_DriveAddPhotos = _resolveComponent("DriveAddPhotos")!
  const _component_DriveAddFiles = _resolveComponent("DriveAddFiles")!
  const _component_drive_add_menu_pop_up = _resolveComponent("drive-add-menu-pop-up")!
  const _component_DriveDesktopAddPhotos = _resolveComponent("DriveDesktopAddPhotos")!
  const _component_DriveDesktopAddFiles = _resolveComponent("DriveDesktopAddFiles")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.isAddPhotosPopUp)
          ? (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
              key: 0,
              onHide: _ctx.hidePopUp,
              "hide-bottom-decoration": "",
              "hide-top-decoration": ""
            }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('upload.case.popup.title')), 1)
              ]),
              body: _withCtx(() => [
                (!_ctx.mainStore.isAndroid)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_3
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.take.picture')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 1,
                      for: "mediaInput",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.CAMERA_IMAGE)))
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_4
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.take.photo')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                      key: 2,
                      onClick: _withModifiers(_ctx.flutterOpenCamera, ["prevent"]),
                      "data-type": "flutter"
                    }, {
                      icon: _withCtx(() => [
                        _hoisted_5
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.take.picture')) + " ", 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 3,
                      for: "mediaInput",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.CAMERA_VIDEO)))
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_6
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.take.video')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives((_openBlock(), _createElementBlock("input", {
                  id: "mediaInput",
                  ref: "mediaInputRef",
                  key: _ctx.mediaLoadedKey,
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addMedia($event))),
                  accept: "image/png, image/jpg, image/jpeg, image/heic, image/bmp, video/*",
                  capture: "environment",
                  type: "file"
                }, null, 544)), [
                  [_vShow, false]
                ]),
                _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.openAddPhotos }, {
                  icon: _withCtx(() => [
                    _hoisted_7
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.from.casedrive')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.openAddFiles }, {
                  icon: _withCtx(() => [
                    _hoisted_8
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.casedrive')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                (!_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_10
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.files')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 5,
                      for: "fileInput",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.GALLERY)))
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_11
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.gallery')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                      key: 6,
                      onClick: _withModifiers(_ctx.flutterOpenFilePicker, ["prevent"]),
                      "data-type": "flutter"
                    }, {
                      icon: _withCtx(() => [
                        _hoisted_12
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.gallery')) + " ", 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 7,
                      for: "fileInput",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.FILE)))
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_13
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.files')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                      key: 8,
                      onClick: _withModifiers(_ctx.flutterOpenFilePicker, ["prevent"]),
                      "data-type": "flutter"
                    }, {
                      icon: _withCtx(() => [
                        _hoisted_14
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.files')) + " ", 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createElementVNode("input", {
                  onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.uploadFiles($event))),
                  id: "fileInput",
                  ref: "fileInput",
                  style: {"visibility":"hidden"},
                  type: "file",
                  multiple: ""
                }, null, 544)
              ]),
              _: 1
            }, 8, ["onHide"]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
          _createVNode(_component_app_take_photo, {
            ref: "appTakePhoto",
            image: _ctx.mediaToCrop,
            labels: _ctx.labels,
            "hide-options-list": "",
            "is-case-cropper": "",
            onOnCancel: _ctx.handleMediaCancel,
            onOnDone: _ctx.handleMultipleUpload,
            onOnRetake: _ctx.handleRetake,
            "z-index": "3500"
          }, null, 8, ["image", "labels", "onOnCancel", "onOnDone", "onOnRetake"])
        ])),
        (_ctx.isAddPhotosPopUp)
          ? (_openBlock(), _createBlock(_component_DriveAddPhotos, {
              key: 1,
              onClose: _ctx.closeAddPhotos
            }, null, 8, ["onClose"]))
          : _createCommentVNode("", true),
        (_ctx.isAddFilesPopUp)
          ? (_openBlock(), _createBlock(_component_DriveAddFiles, {
              key: 2,
              onClose: _ctx.closeAddFiles
            }, null, 8, ["onClose"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
        (!_ctx.isAddPhotosPopUp && !_ctx.isAddFilesPopUp)
          ? (_openBlock(), _createBlock(_component_drive_add_menu_pop_up, {
              key: 0,
              class: "popup-menu",
              desktopPopUpPosition: _ctx.posData,
              onHide: _ctx.hidePopUp,
              "hide-bottom-decoration": "",
              "hide-top-decoration": ""
            }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('upload.case.popup.title')), 1)
              ]),
              body: _withCtx(() => [
                _createVNode(_component_bottom_pop_up_item, {
                  class: "popup-item",
                  onClick: _ctx.openAddPhotos
                }, {
                  icon: _withCtx(() => [
                    _hoisted_16
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.from.casedrive')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_bottom_pop_up_item, {
                  class: "popup-item",
                  onClick: _ctx.openAddFiles
                }, {
                  icon: _withCtx(() => [
                    _hoisted_17
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.casedrive')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createElementVNode("label", _hoisted_18, [
                  _createVNode(_component_bottom_pop_up_item, { class: "popup-item" }, {
                    icon: _withCtx(() => [
                      _hoisted_19
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.files')) + " ", 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("input", {
                    onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.uploadFiles($event))),
                    id: "fileInput",
                    ref: "fileInput",
                    style: {"visibility":"hidden"},
                    type: "file",
                    multiple: ""
                  }, null, 544)
                ])
              ]),
              _: 1
            }, 8, ["desktopPopUpPosition", "onHide"]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
          _createVNode(_component_app_take_photo, {
            ref: "appTakePhoto",
            image: _ctx.mediaToCrop,
            labels: _ctx.labels,
            "hide-options-list": "",
            "is-case-cropper": "",
            onOnCancel: _ctx.handleMediaCancel,
            onOnDone: _ctx.handleMultipleUpload,
            onOnRetake: _ctx.handleRetake,
            "z-index": "3500"
          }, null, 8, ["image", "labels", "onOnCancel", "onOnDone", "onOnRetake"])
        ])),
        (_ctx.isAddPhotosPopUp)
          ? (_openBlock(), _createBlock(_component_DriveDesktopAddPhotos, {
              key: 1,
              onClose: _ctx.closeAddPhotos
            }, null, 8, ["onClose"]))
          : _createCommentVNode("", true),
        (_ctx.isAddFilesPopUp)
          ? (_openBlock(), _createBlock(_component_DriveDesktopAddFiles, {
              key: 2,
              onClose: _ctx.closeAddFiles,
              class: "d-drive-add-files"
            }, null, 8, ["onClose"]))
          : _createCommentVNode("", true)
      ]))
}